import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_app/builder/schedules/forms/formId")({
    component: () => <div>Hello /_app/builder/schedules/forms/formId!</div>,
});
